"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }/* Staff Forms commands over the signed-in socket. */
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);





 const listForms = (r) => _client2.default.send('ListForms', r) ; exports.listForms = listForms
 const getForm = (r) => _client2.default.send('GetForm', r) ; exports.getForm = getForm
 const importForm = (r) => _client2.default.send('ImportForm', r) ; exports.importForm = importForm
 const addFormPages = (r) => _client2.default.send('AddFormPages', r) ; exports.addFormPages = addFormPages
 const editFormFields = (r) => _client2.default.send('EditFormFields', r) ; exports.editFormFields = editFormFields
 const detectFormFields = (r) =>
  _client2.default.send('DetectFormFields', r) ; exports.detectFormFields = detectFormFields
 const askFormAdmin = (r) => _client2.default.send('AskFormAdmin', r) ; exports.askFormAdmin = askFormAdmin
 const publishForm = (r) => _client2.default.send('PublishForm', r) ; exports.publishForm = publishForm
 const deleteForm = (r) => _client2.default.send('DeleteForm', r) ; exports.deleteForm = deleteForm
 const getFormSendPrefill = (r) =>
  _client2.default.send('GetFormSendPrefill', r) ; exports.getFormSendPrefill = getFormSendPrefill
 const sendForm = (r) => _client2.default.send('SendForm', r) ; exports.sendForm = sendForm
 const getFormStatuses = (r) =>
  _client2.default.send('GetFormStatuses', r) ; exports.getFormStatuses = getFormStatuses
 const getSentForm = (r) => _client2.default.send('GetSentForm', r) ; exports.getSentForm = getSentForm
 const listSentForms = (r) => _client2.default.send('ListSentForms', r) ; exports.listSentForms = listSentForms
